import { Box, MenuItem } from '@mui/material'
import { Field, useField } from 'formik'
import React from 'react'
import { CustomTextField } from 'src/form'

const EDUCATION_LEVEL_SELECTIONS = [
  {
    label: 'High school diploma or equivalent',
    value: 'HIGH_SCHOOL_DIPLOMA_OR_EQUIVALENT',
  },
  { label: 'Some college', value: 'SOME_COLLEGE' },
  { label: "Bachelor's degree", value: 'BACHELOR_DEGREE' },
  { label: 'Graduate or professional degree', value: 'GRADUATE_OR_PROFESSIONAL_DEGREE' },
  { label: 'Other', value: 'OTHER' },
]

const EDUCATION_LEVEL_FIELD_NAME = 'patient.educationLevel'
const OTHER_EDUCATION_FIELD_NAME = 'patient.otherEducation'

export const EducationLevelField = () => {
  const [field] = useField(EDUCATION_LEVEL_FIELD_NAME)

  const isOtherSelected = field.value === 'OTHER'

  return (
    <Box>
      <Field
        component={CustomTextField}
        fullWidth
        label="Level of education"
        name={EDUCATION_LEVEL_FIELD_NAME}
        type="select"
      >
        {EDUCATION_LEVEL_SELECTIONS.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Field>

      {isOtherSelected && (
        <Box mt={2}>
          <Field
            component={CustomTextField}
            fullWidth
            label="Other education completed"
            name={OTHER_EDUCATION_FIELD_NAME}
            multiline
            minRows={3}
            placeholder="Other education completed"
          />
        </Box>
      )}
    </Box>
  )
}
